import React, { useEffect, useState } from 'react';
import { TableColumn } from 'react-data-table-component';

import { DefaultTable } from 'src/components';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IContact } from 'src/interfaces';

export const EmployeeContactsTable: React.FC<{
  columns: TableColumn<any>[];
}> = ({ columns }) => {
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const { loading } = useTypedSelector(state => state.employees);
  const { config } = useTypedSelector(state => state.config.data);
  const { getEmployeeContacts } = useActions();
  const [data, setData] = useState<IContact[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    setData(selectedEmployee.contacts || []);
    setTotalRows(selectedEmployee.totalContacts || 0);
  }, [selectedEmployee.contacts]);

  const fetchDependents = async (page: number) => {
    const companyId = config?.selectedCompanyId || '';
    const employeeId = selectedEmployee.employee?.id || '';
    getEmployeeContacts({ page, companyId, limit, employeeId });
  };

  useEffect(() => {
    if (config?.selectedCompanyId) fetchDependents(1);
  }, [config?.selectedCompanyId]);

  const handlePageChange = (page: number) => {
    fetchDependents(page);
  };

  const handlePerRowsChange = async (newLimit: number, page: number) => {
    const companyId = config?.selectedCompanyId || '';
    const employeeId = selectedEmployee.employee?.id || '';
    getEmployeeContacts({ page, companyId, limit: newLimit, employeeId });
    setLimit(newLimit);
  };

  return (
    <DefaultTable
      columns={columns}
      data={data}
      progressPending={loading}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
    />
  );
};
